import type { ReactNode } from "react";

interface HeaderProps {
  title?: string;
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
}

export function Header({ title, left, right, className = "" }: HeaderProps) {
  return (
    <header
      className={`sticky top-0 z-50 border-b border-black/[0.08] bg-white/80 pt-[env(safe-area-inset-top)] backdrop-blur-xl backdrop-saturate-150 ${className}`}
    >
      <div className="flex h-11 items-center px-4">
        <div className="flex flex-1 items-center justify-start">{left}</div>
        <h1 className="truncate px-2 text-[17px] font-semibold text-neutral-900">{title}</h1>
        <div className="flex flex-1 items-center justify-end gap-3">{right}</div>
      </div>
    </header>
  );
}